/* ONDIVO 20/10/2026 : tiroir panier v15.
   Remplace l'ancien cart-drawer.js en gardant son API publique (plan v15 §1.1) :
   open, close, renderContents, getSectionsToRender, setActiveElement,
   addItemToCart (sticky-add-to-cart.liquid). L'ancien fichier est sauve dans
   assets/cart-drawer-avant-v15.js (retour arriere : le recopier ici, et
   snippets/cart-drawer-avant-v15.liquid dans snippets/cart-drawer.liquid).

   Comment ca marche
   -----------------
   - Le panier vient d'abord du bloc JSON #odv-data (premier rendu juste, sans
     requete), puis de /cart.js, qui a TOUJOURS raison.
   - Chaque appui modifie "l'etat voulu" et s'affiche tout de suite (panier
     projete, prix calcules par OdvPrix). Seul le bouton de paiement attend.
   - Une seule requete en vol. OdvMoteur.planifier() compare le panier lu a
     l'etat voulu et rend UNE operation ; on l'execute, on relit, on recommence.
   - Requetes en XMLHttpRequest : rappi-front.js remplace window.fetch sur tout
     le site et peut reecrire cart/change et cart/add ; il ne touche pas a XHR.
   - Rendu par "morph" (mise a jour noeud par noeud) : images, focus et
     defilement conserves, pas de clignotement. */
(function () {
  'use strict';

  var P = window.OdvPrix, M = window.OdvMoteur;
  var RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var D = null, CFG = null, F = null;
  var S = {
    panier: null, E: null, Eaff: null, lu: false, enVol: false, sale: false, diff: false,
    attenteFiche: false, ouvert: false, kitRetire: null, err: '', dernierTotal: null,
    dernierAppui: -1e9, filet: null, filetFiche: null, minuteur: null, histoire: false, scrollY: 0,
    memo: {}, dernierLu: 0, cache: false, payeRefuse: false
  };

  /* ------------------------------------------------------------ donnees */
  function donnees() {
    if (D) return true;
    var el = document.getElementById('odv-data');
    if (!el || !P || !M) return false;
    try { D = JSON.parse(el.textContent); } catch (e) { return false; }
    var taux = 1;
    try { var t = parseFloat(Shopify.currency.rate); if (isFinite(t) && t > 0) taux = t; } catch (e) {}
    CFG = M.config({ ids: D.ids, bundles: D.bundles || [], pays: D.pays, unite: D.unite, taux: taux }, P);
    CFG.memo = S.memo;
    F = P.format(D.modele);
    S.panier = D.panier;
    S.E = M.etat(D.panier, CFG);
    return true;
  }

  function argent(c) { return P.argent(c, F); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* -------------------------------------------------------------- reseau */
  function xhr(methode, url, corps) {
    return new Promise(function (ok, ko) {
      var x = new XMLHttpRequest();
      x.open(methode, url);
      x.setRequestHeader('Accept', 'application/json');
      if (corps) x.setRequestHeader('Content-Type', 'application/json');
      x.timeout = 15000;
      x.onload = function () {
        var j = null;
        try { j = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300 && j) return ok(j);
        var e = new Error((j && (j.description || j.message)) || 'HTTP ' + x.status);
        e.status = x.status;
        ko(e);
      };
      x.onerror = x.ontimeout = function () { var e = new Error('rete'); e.status = 0; ko(e); };
      x.send(corps ? JSON.stringify(corps) : null);
    });
  }

  function lirePanier() { return xhr('GET', RACINE + 'cart.js').then(function (c) { S.dernierLu = Date.now(); return c; }); }

  function executer(op) {
    if (op.type === 'change') {
      /* Retamponnage : quantite ET proprietes completes en une seule requete. */
      return xhr('POST', RACINE + 'cart/change.js', { id: op.id, quantity: op.quantity, properties: op.properties });
    }
    if (op.type === 'update') {
      var c = { updates: op.updates };
      if (op.attributes) c.attributes = op.attributes;
      return xhr('POST', RACINE + 'cart/update.js', c);
    }
    /* add.js ne rend que les lignes ajoutees : on relit le panier. */
    return xhr('POST', RACINE + 'cart/add.js', { items: op.items }).then(lirePanier);
  }

  /* ----------------------------------------------- file et reconciliation */
  function verite(c) { return M.etat(c, CFG); }

  function pomper() {
    if (!donnees()) return;
    if (S.enVol) { S.sale = true; return; }
    S.enVol = true;
    rendre();
    clearTimeout(S.filet);
    /* Filet de 8 s : on relit, on affiche la verite, on debloque. Si la
       reponse lente arrive ensuite, fin() refait le rendu. */
    S.filet = setTimeout(function () {
      lirePanier().then(function (c) {
        if (!S.enVol) return;
        S.panier = c; S.diff = false; S.lu = true; S.force = true; rendre();
      }, function () {});
    }, 8000);
    var memo = S.memo, essais = 0, tours = 0;
    (function tour() {
      if (S.sale) S.sale = false;
      var op = tours++ < 8 ? M.planifier(S.panier, S.E, CFG, memo) : null;
      if (!op) return fin();
      executer(op).then(function (c) { S.panier = c; tour(); }, function (e) {
        essais++;
        lirePanier().then(function (c) { S.panier = c; }, function () {}).then(function () {
          if (essais > 1 || e.status === 0) {
            S.err = e.status === 422 ? 'Quantità non disponibile.' : e.status === 0 ? 'Connessione assente. Riprova.' : 'Si è verificato un errore. Riprova.';
            S.E = verite(S.panier);
            S.douteux = true;
            return fin();
          }
          tour();
        });
      });
    })();
  }

  function fin() {
    clearTimeout(S.filet);
    S.enVol = false; S.force = false;
    if (S.sale) { S.sale = false; return pomper(); }
    S.diff = false;
    S.lu = true;
    if (!S.err) S.douteux = false;
    S.E = verite(S.panier);
    rendre();
    if (S.panier) bulle(S.panier.item_count);
  }

  /* Compteur du header. updateBubbleCount (cart.js:219) vide la bulle a 0
     puis en cree une seconde au retour (deux noeuds, dont un vide) : on
     reutilise la premiere et on retire les doublons. */
  function bulle(n) {
    var h = document.getElementById('cart-icon-bubble');
    if (!h) return;
    var bs = h.querySelectorAll('.cart-count-bubble'), b = bs[0];
    for (var i = 1; i < bs.length; i++) bs[i].parentNode.removeChild(bs[i]);
    if (!n) { if (b) b.innerHTML = ''; return; }
    if (!b) {
      b = document.createElement('div');
      b.className = 'cart-count-bubble';
      b.style.backgroundColor = 'var(--global-section-text-color)';
      b.style.color = 'var(--global-section-background-color)';
      h.appendChild(b);
    }
    var s = b.querySelector('span');
    if (!s) { b.innerHTML = '<span aria-hidden="true"></span>'; s = b.firstChild; }
    s.textContent = String(n);
  }

  function appui(fn) {
    var t = performance.now();
    if (t - S.dernierAppui < 250) return;
    S.dernierAppui = t;
    if (!donnees() || S.attenteFiche) return;
    S.err = '';
    S.payeRefuse = false;
    fn(S.E);
    S.diff = true;
    rendre();
    pomper();
  }

  /* ONDIVO 30/10/2026 VIP : la ligne du kit VIP a aussi son +/-. Meme regle
     que le kit public (odv-prix : palier = offre de plus grande quantite <= q),
     appliquee au bundle de la ligne (_rapi_bundles, present dans odv-data) :
     une requete change.js avec quantite ET tampon d'offre (atomique), puis le
     cadeau du palier est ajoute ou retire. Les lignes publiques n'y passent
     jamais (elles sont kit/cr/mk, pas "autre"). */
  function bundleVip(l) {
    var o = M.offreLigne(l), id = M.bundleLigne(l);
    if (!o || !o.main || id === null || M.role(l, CFG) !== 'autre') return null;
    var bs = (D && D.bundles) || [];
    for (var i = 0; i < bs.length; i++) if (String(bs[i].id) === id) return bs[i];
    return null;
  }
  function varianteDe(pid) {
    var r = ['kit', 'cr', 'mk', 'eb'];
    for (var i = 0; i < r.length; i++) if (CFG.ids[r[i]] && Number(CFG.ids[r[i]].p) === Number(pid)) return CFG.ids[r[i]].v;
    return null;
  }
  function quantiteVip(l, b, q) {
    var o = P.palier(b, q) || (b.offers && b.offers[0]);
    if (!o) return;
    var props = {}, k;
    for (k in (l.properties || {})) if (Object.prototype.hasOwnProperty.call(l.properties, k)) props[k] = l.properties[k];
    props.__rapi_offer = JSON.stringify({ main: true, offer: o.identifier_id });
    S.enVol = true; S.lu = false; rendre();
    var fin = function () { S.enVol = false; relire(); };
    xhr('POST', RACINE + 'cart/change.js', { id: l.key, quantity: q, properties: props }).then(function (c) {
      var g = P.cadeau(o), vG = g ? varianteDe(g.shopify_product_id) : null, maj = {}, n = 0, garde = false;
      (c.items || []).forEach(function (x) {
        var ox = M.offreLigne(x);
        if (!ox || !ox.gift || M.bundleLigne(x) !== String(b.id)) return;
        if (vG && !garde && Number(x.variant_id) === Number(vG) && String(ox.offer) === String(o.identifier_id)) { garde = true; if (x.quantity !== 1) { maj[x.key] = 1; n++; } }
        else { maj[x.key] = 0; n++; }
      });
      var p = n ? xhr('POST', RACINE + 'cart/update.js', { updates: maj }) : Promise.resolve();
      return p.then(function () {
        if (!vG || garde) return;
        return xhr('POST', RACINE + 'cart/add.js', { items: [{ id: vG, quantity: 1, properties: { __rapi_offer: JSON.stringify({ offer: o.identifier_id, gift: true }), _rapi_bundles: String(b.id) } }] });
      });
    }).then(fin, function (e) { S.err = e.message; fin(); });
  }

  function relire() {
    if (!donnees()) return;
    S.lu = false;
    rendre();
    lirePanier().then(function (c) {
      if (S.enVol || S.attenteFiche || S.test) return;
      S.panier = c;
      var v = verite(c);
      S.E = v;
      pomper();
    }, function () { S.lu = true; S.err = 'Connessione assente. Riprova.'; rendre(); });
  }

  /* ------------------------------------------------------------- rendu */
  var IC = {
    trash: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="#8A857F" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>',
    clock: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1D130A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9 2h6"/></svg>',
    truck: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>'
  };
  function carte(w, inner, bg) { return '<svg width="' + w + '" height="26" viewBox="0 0 ' + w + ' 26" aria-hidden="true"><rect x=".5" y=".5" width="' + (w - 1) + '" height="25" rx="4" fill="' + (bg || '#fff') + '" stroke="#E2DED8"/>' + inner + '</svg>'; }
  var LOGO = {
    cod: carte(84, '<rect x="6" y="8" width="16" height="10" rx="1.5" fill="#E8F3EA" stroke="#2E7D4F" stroke-width="1.2"/><circle cx="14" cy="13" r="2.4" fill="none" stroke="#2E7D4F" stroke-width="1.2"/><text x="26" y="16.3" font-family="Arial" font-weight="700" font-size="8" fill="#1D130A">Contrassegno</text>'),
    poste: carte(40, '<text x="20" y="16.3" text-anchor="middle" font-family="Arial" font-weight="700" font-size="7.6" fill="#1C3F94">PostePay</text>', '#FFE01A'),
    mc: carte(40, '<circle cx="16.5" cy="13" r="6.5" fill="#EB001B"/><circle cx="23.5" cy="13" r="6.5" fill="#F79E1B" fill-opacity=".9"/>'),
    visa: carte(40, '<text x="20" y="17.5" text-anchor="middle" font-family="Arial" font-style="italic" font-weight="700" font-size="11" fill="#1A1F71">VISA</text>'),
    apay: carte(40, '<text x="20" y="17" text-anchor="middle" font-family="Arial" font-weight="700" font-size="10" fill="#000">Pay</text><path d="M11.2 9.6c.5-.6.8-1.3.7-2-.7 0-1.4.4-1.9 1-.4.5-.8 1.2-.7 1.9.7.1 1.4-.4 1.9-.9z" fill="#000"/>'),
    ppal: carte(40, '<text x="20" y="16.5" text-anchor="middle" font-family="Arial" font-style="italic" font-weight="700" font-size="9" fill="#003087">Pay<tspan fill="#009CDE">Pal</tspan></text>'),
    klar: carte(40, '<text x="20" y="17" text-anchor="middle" font-family="Arial" font-weight="700" font-size="9" fill="#17120F">Klarna.</text>', '#FFB3C7'),
    twint: carte(40, '<text x="20" y="16.8" text-anchor="middle" font-family="Arial" font-weight="700" font-size="8.6" fill="#fff">TWINT</text>', '#000')
  };
  var NOM = { kit: 'DermaGlow + | Sistema di Microinfusione', cr: 'ReActive+ | Crema Riparatrice', mk: 'RePlump+ | Maschera al Collagene' };
  var PALIERS = { cr: [null, '1 CREMA', '2 CREME', '3 CREME'], mk: [null, '4 MASCHERE', '6 MASCHERE + 2 GRATIS', '8 MASCHERE + 4 GRATIS'] };

  function libelle(r, q, remise) {
    if (r === 'kit') return remise && q % 2 === 0 ? (q / 2) + ' KIT + ' + (q / 2) + ' GRATIS' : q + ' KIT';
    if (remise && q <= 3) return PALIERS[r][q];
    if (r === 'cr') return q === 1 ? '1 CREMA' : q + ' CREME';
    return q === 1 ? '4 MASCHERE' : q + ' CONFEZIONI';
  }

  function prixBloc(l) {
    var remise = l.final_line_price < l.original_line_price;
    return '<div class="odv-pr">' + (remise ? '<span class="odv-save">Risparmia ' + argent(l.original_line_price - l.final_line_price) + '</span>' : '') +
      '<span class="odv-pl">' + (remise ? '<span class="odv-old">' + argent(l.original_line_price) + '</span>' : '') + '<span class="odv-now">' + argent(l.final_line_price) + '</span></span></div>';
  }

  function selecteur(a, q, min, max) {
    return '<div class="odv-step"><button type="button" aria-label="Meno" data-a="' + a + '-"' + (q > min ? '' : ' disabled') + '>−</button><span>' + q + '</span><button type="button" aria-label="Più" data-a="' + a + '+"' + (q < max ? '' : ' disabled') + '>+</button></div>';
  }

  function ligneKit(l) {
    var q = l.quantity, remise = l.final_line_price < l.original_line_price;
    return '<div class="odv-item" data-k="kit"><img class="odv-thumb" decoding="async" src="' + esc(D.img.kit) + '" alt="" width="66" height="66"><div class="odv-bd"><div class="odv-top"><div><div class="odv-name">' + NOM.kit + '</div><div class="odv-offer">' + libelle('kit', q, remise) + '</div><div class="odv-incl">' + q + (q > 1 ? ' mesi' : ' mese') + ' di trattamento</div></div><button type="button" class="odv-trash" aria-label="Rimuovi" data-a="kit-x">' + IC.trash + '</button></div>' +
      '<div class="odv-bot">' + selecteur('kit', q, 1, 10) + prixBloc(l) + '</div></div></div>';
  }

  function ligneAcc(r, l) {
    var q = l.quantity, remise = l.final_line_price < l.original_line_price;
    return '<div class="odv-item odv-sm" data-k="' + r + '"><img class="odv-thumb" decoding="async" src="' + esc(D.img[r]) + '" alt="" width="56" height="56"><div class="odv-bd"><div class="odv-top"><div><div class="odv-name">' + NOM[r] + '</div><div class="odv-offer">' + libelle(r, q, remise) + '</div></div><button type="button" class="odv-trash" aria-label="Rimuovi" data-a="' + r + '-x">' + IC.trash + '</button></div>' +
      '<div class="odv-bot">' + selecteur(r, q, 1, 3) + prixBloc(l) + '</div></div></div>';
  }

  function ligneAutre(l) {
    var t = l.product_title || l.title || '';
    if (l.variant_title && !/default/i.test(l.variant_title)) t += ' · ' + l.variant_title;
    var k = esc(l.key);
    /* ONDIVO 30/10/2026 VIP : pas de +/- sur un cadeau offert ni sur le kit VIP
       (son palier Rapi vaut pour une quantite precise, le changer ferait
       sauter le prix). La poubelle reste. */
    /* Cadeau : quantite fixe. Kit VIP : +/- gere par quantiteVip (palier + cadeau). */
    var o = M.offreLigne(l), fixe = !!(o && o.gift);
    return '<div class="odv-item odv-sm" data-k="a-' + k + '">' + (l.image ? '<img class="odv-thumb" decoding="async" src="' + esc(l.image) + '" alt="" width="56" height="56">' : '') + '<div class="odv-bd"><div class="odv-top"><div><div class="odv-name">' + esc(t) + '</div></div><button type="button" class="odv-trash" aria-label="Rimuovi" data-a="au-x" data-key="' + k + '">' + IC.trash + '</button></div>' +
      '<div class="odv-bot">' + (fixe && CFG.ids.eb && Number(l.product_id) === Number(CFG.ids.eb.p) ? '<div class="odv-step"><span>' + l.quantity + '</span></div>' : fixe ? selecteur('cad', l.quantity, 1, 4).replace(/data-a="cad([-+])"/g, 'data-a="cad$1" data-key="' + k + '"') : selecteur('au', l.quantity, 1, 10).replace(/data-a="au([-+])"/g, 'data-a="au$1" data-key="' + k + '"')) +
      /* Cadeau a 0 : "GRATIS" au lieu de 0,00 (Aurelien, 30/10/2026). */
      (o && o.gift && l.final_line_price === 0 && l.original_line_price > 0
        ? '<div class="odv-pr"><span class="odv-pl"><span class="odv-old">' + argent(l.original_line_price) + '</span><span class="odv-now">GRATIS</span></span></div>'
        : prixBloc(l)) + '</div></div></div>';
  }

  function ligneEbook(l) {
    var gratuit = l.final_line_price === 0;
    return '<div class="odv-gift" data-k="eb">' + (D.img.eb ? '<img decoding="async" src="' + esc(D.img.eb) + '" alt="" width="44" height="44">' : '') + '<div class="odv-gt">Guida Anti‑Età<small>E-book · <s>' + argent(l.original_line_price || D.unite.eb) + '</s></small></div><div class="odv-gr"><b>' + (gratuit ? 'In regalo' : argent(l.final_line_price)) + '</b><button type="button" class="odv-trash" aria-label="Rimuovi" data-a="eb-x">' + IC.trash + '</button></div></div>';
  }

  function suggestion(r) {
    return '<div class="odv-row" data-k="r-' + r + '"><img decoding="async" src="' + esc(D.img[r]) + '" alt="" width="44" height="44"><div class="odv-rt">' + NOM[r] + '<small>' + (r === 'mk' ? '4 maschere · ' : '') + argent(D.unite[r]) + '</small></div><button type="button" class="odv-add" data-a="add-' + r + '">Aggiungi</button></div>';
  }

  function vue() {
    if (S.attenteFiche && S.Eaff) return M.projeter(S.panier, S.Eaff, CFG);
    if (S.diff || (S.enVol && !S.force)) return M.projeter(S.panier, S.E, CFG);
    return S.panier || { items: [], total_price: 0, item_count: 0 };
  }

  function html(c) {
    var L = { kit: [], cr: [], mk: [], eb: [], autre: [] };
    /* ONDIVO 30/10/2026 VIP : meme classement que le moteur (classer), pour que
       l'ebook offert du 2+3 VIP s'affiche avec sa ligne VIP, pas en ebook public. */
    var horsT = {};
    M.classer({ items: (c.items || []).filter(function (l) { return !l.role; }) }, CFG).autre.forEach(function (l) { horsT[l.key] = true; });
    (c.items || []).forEach(function (l) { L[l.role || (horsT[l.key] ? 'autre' : M.role(l, CFG))].push(l); });
    /* ONDIVO 30/10/2026 VIP (Aurelien) : le kit d'abord, les cadeaux ensuite. */
    var estCadeau = function (l) { var o = M.offreLigne(l); return o && o.gift ? 1 : 0; };
    L.autre = L.autre.map(function (l, i) { return { l: l, i: i }; }).sort(function (a, b) { return (estCadeau(a.l) - estCadeau(b.l)) || (a.i - b.i); }).map(function (x) { return x.l; });
    var lignes = (c.items || []).length;
    var attente = !S.lu && !lignes;
    var vide = !lignes && S.lu;
    var occupe = (S.enVol && !S.force) || S.attenteFiche || !S.lu;
    var z = P.zone(D.pays), h = '';

    var economie = 0;
    (c.items || []).forEach(function (l) { if (l.original_line_price > l.final_line_price) economie += l.original_line_price - l.final_line_price; });

    if (S.err) h += '<div class="odv-err" data-k="err" role="alert">' + esc(S.err) + '</div>';
    L.kit.forEach(function (l) { h += ligneKit(l); });
    /* ONDIVO 30/10/2026 VIP : le kit VIP en tete, avant creme et masques
       (Aurelien). Seules les lignes dont le bundle est un bundle VIP connu du
       tiroir montent ; les autres lignes "autre" gardent leur place. */
    var vipEnTete = L.autre.filter(function (l) { return !!bundleVip(l); });
    vipEnTete.forEach(function (l) { h += ligneAutre(l); });
    L.autre = L.autre.filter(function (l) { return vipEnTete.indexOf(l) === -1; });
    if (!L.kit.length && S.kitRetire) h += '<div class="odv-undo" data-k="undo"><span>Kit rimosso</span><button type="button" data-a="undo">Annulla</button></div>';
    L.eb.forEach(function (l) { h += ligneEbook(l); });
    L.cr.forEach(function (l) { h += ligneAcc('cr', l); });
    L.mk.forEach(function (l) { h += ligneAcc('mk', l); });
    L.autre.forEach(function (l) { h += ligneAutre(l); });
    var reco = ['cr', 'mk'].filter(function (r) { return CFG.ids[r] && CFG.ids[r].v && !L[r].length; });
    if (reco.length && lignes) h += '<div class="odv-reco" data-k="reco"><div class="odv-rh">Per migliorare i risultati della microinfusione</div>' + reco.map(suggestion).join('') + '</div>';

    var gauche = Math.max(0, Math.round((fin10() - Date.now()) / 1000));
    var haut = (gauche > 0 && lignes ? '<div class="odv-timer" data-k="tm">' + IC.clock + '<span>Carrello riservato per <b id="odv-tm">' + mmss(gauche) + '</b></span></div>' : '') +
      '<div class="odv-head" data-k="hd"><div class="odv-h">Il tuo carrello</div><button type="button" class="odv-x" aria-label="Chiudi" data-a="close">&times;</button></div>';
    var date = P.livraison(D.pays, new Date());
    if (lignes) haut += '<div class="odv-ship" data-k="sh"><div class="odv-sr"><span>&#127881; <b>Spedizione offerta</b></span><span>' + (date ? 'Arriva ' + P.dateCourte(date) : '<span class="odv-ai">Arriva in </span>5-7 giorni') + '</span></div><div class="odv-bar"><span class="odv-tr"></span><div class="odv-ic">' + IC.truck + '</div></div></div>';

    var corps = haut + h;
    if (attente) corps += '<div class="odv-emb" data-k="wait"><i class="odv-spin"></i></div>';
    if (vide) corps += '<div class="odv-empty" data-k="vide">Il tuo carrello è vuoto</div><div class="odv-emb" data-k="vb"><button type="button" class="odv-emc" data-a="close">Continua lo shopping</button></div>';

    var pied = '';
    if (lignes) {
      var code = '';
      (c.cart_level_discount_applications || []).forEach(function (d) {
        if (d.total_allocated_amount) code += '<div class="odv-code" data-k="cd"><span>Sconto ' + esc(d.title || '') + '</span><span>−' + argent(d.total_allocated_amount) + '</span></div>';
      });
      var pay = z === 'CH' ? LOGO.visa + LOGO.mc + LOGO.twint + LOGO.ppal + LOGO.klar : z === 'EU' ? LOGO.visa + LOGO.mc + LOGO.apay + LOGO.ppal + LOGO.klar : LOGO.cod + LOGO.poste + LOGO.visa + LOGO.mc + LOGO.ppal + LOGO.klar;
      pied = '<div class="odv-foot' + (occupe ? ' odv-wait' : '') + '">' + code +
        '<div class="odv-recap">' + (economie ? '<span class="odv-sv">Risparmi ' + argent(economie) + '</span>' : '<span></span>') + '<span class="odv-tt"><span class="odv-lbl">Totale</span><b>' + argent(c.total_price) + '</b></span></div>' +
        '<button type="button" class="odv-cta" data-a="pay"' + (occupe ? ' disabled' : '') + '><span class="odv-cl">PROCEDI AL PAGAMENTO SICURO</span><span class="odv-sep">·</span><span class="odv-cp"><span class="odv-cpv">' + argent(c.total_price) + '</span>' + (occupe ? '<i class="odv-spin odv-spw"></i>' : '') + '</span></button>' +
        '<div class="odv-pay"><div class="odv-payrow">' + pay + '</div></div><div class="odv-trust"><b>' + (z === 'IT' ? 'Paghi alla consegna' : 'Pagamento protetto') + '</b> · Garanzia 90 <span class="odv-lg">giorni</span><span class="odv-gg">gg</span></div></div>';
    }
    return '<div class="odv-scroll">' + corps + '</div>' + pied;
  }

  /* --- morph : met a jour le DOM existant au lieu de le remplacer -------- */
  function memeNoeud(a, b) {
    if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) return false;
    if (a.nodeType === 1) return (a.getAttribute('data-k') || '') === (b.getAttribute('data-k') || '');
    return true;
  }
  function morphAttrs(a, b) {
    var i, n;
    for (i = a.attributes.length - 1; i >= 0; i--) { n = a.attributes[i].name; if (!b.hasAttribute(n)) a.removeAttribute(n); }
    for (i = 0; i < b.attributes.length; i++) { n = b.attributes[i]; if (a.getAttribute(n.name) !== n.value) a.setAttribute(n.name, n.value); }
    if (a.nodeName === 'BUTTON') a.disabled = b.hasAttribute('disabled');
  }
  function morphEnfants(a, b) {
    var ancien = Array.prototype.slice.call(a.childNodes), neuf = Array.prototype.slice.call(b.childNodes);
    var parCle = {};
    ancien.forEach(function (n) { if (n.nodeType === 1 && n.getAttribute('data-k')) parCle[n.getAttribute('data-k')] = n; });
    var j = 0;
    for (var i = 0; i < neuf.length; i++) {
      var nb = neuf[i], cle = nb.nodeType === 1 ? nb.getAttribute('data-k') : null, cible = null;
      if (cle && parCle[cle] && memeNoeud(parCle[cle], nb)) cible = parCle[cle];
      else if (!cle) { while (j < ancien.length && (ancien[j].nodeType === 1 && ancien[j].getAttribute('data-k'))) j++; if (j < ancien.length && memeNoeud(ancien[j], nb)) cible = ancien[j++]; }
      var ref = a.childNodes[i] || null;
      if (cible) {
        if (cible !== ref) a.insertBefore(cible, ref);
        morph(cible, nb);
        if (cle) delete parCle[cle];
      } else {
        a.insertBefore(nb.cloneNode(true), ref);
      }
    }
    while (a.childNodes.length > neuf.length) a.removeChild(a.lastChild);
  }
  function morph(a, b) {
    if (a.nodeType === 3 || a.nodeType === 8) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
    morphAttrs(a, b);
    morphEnfants(a, b);
  }

  /* Toutes les lectures d'abord, puis les ecritures : une seule mise en page
     forcee au lieu d'une par ligne (trace Dmitri : 146 ms sous CPU x4). */
  function mesurer(racine) {
    var ecrire = [];
    var cb = racine.querySelector('.odv-cta');
    if (cb && cb.scrollWidth > cb.clientWidth + 1) ecrire.push([cb, 'odv-tight']);
    var rc = racine.querySelector('.odv-recap');
    if (rc) {
      var sv = rc.querySelector('.odv-sv'), tt = rc.querySelector('.odv-tt');
      if (sv && tt) {
        var a = sv.getBoundingClientRect(), b = tt.getBoundingClientRect(), r = rc.getBoundingClientRect();
        if (a.right + 6 > b.left || rc.scrollWidth > rc.clientWidth + 1 || b.right > r.right + 1) ecrire.push([rc, 'odv-tight']);
      }
    }
    var bots = racine.querySelectorAll('.odv-bot');
    for (var i = 0; i < bots.length; i++) {
      var st = bots[i].querySelector('.odv-step'), t = bots[i].querySelector('.odv-save');
      if (st && t && t.getBoundingClientRect().left < st.getBoundingClientRect().right + 4) ecrire.push([bots[i], 'odv-stk']);
    }
    for (i = 0; i < ecrire.length; i++) ecrire[i][0].classList.add(ecrire[i][1]);
  }

  function rendre(force) {
    if (!donnees()) return;
    var pan = document.getElementById('odv-pan');
    if (!pan) return;
    var c = vue();
    var h = html(c);
    window.OdvTiroir = { panier: S.panier, vue: c, etat: S.E, occupe: S.enVol || S.attenteFiche || !S.lu };
    if (!force && h === S.dernierHtml) return;
    S.dernierHtml = h;
    var sc = pan.querySelector('.odv-scroll'), st = sc ? sc.scrollTop : 0;
    var t = document.createElement('div');
    t.innerHTML = h;
    if (!pan.querySelector('.odv-scroll')) pan.innerHTML = '';
    morphEnfants(pan, t);
    mesurer(pan);
    sc = pan.querySelector('.odv-scroll');
    if (sc && sc.scrollTop !== st) sc.scrollTop = st;
    var host = document.getElementById('odv-host');
    if (host) host.classList.toggle('is-empty', !(c.items || []).length);
    if (S.ouvert && S.dernierTotal !== null && S.dernierTotal !== c.total_price) {
      var rc = pan.querySelector('.odv-recap');
      if (rc) { rc.classList.remove('odv-flash'); void rc.offsetWidth; rc.classList.add('odv-flash'); }
    }
    S.dernierTotal = c.total_price;
    window.OdvTiroir = { panier: S.panier, vue: c, etat: S.E, occupe: S.enVol || S.attenteFiche || !S.lu };
  }

  /* ---------------------------------------------------------- minuteur */
  var CLE_FIN = 'ondivo_cart_end';
  function fin10() {
    var f = 0;
    try { f = +sessionStorage.getItem(CLE_FIN) || 0; } catch (e) {}
    return f || S.fin10 || 0;
  }
  function poserFin10() {
    if (fin10()) return;
    S.fin10 = Date.now() + 600000;
    try { sessionStorage.setItem(CLE_FIN, String(S.fin10)); } catch (e) {}
  }
  function mmss(s) { return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); }
  function tic() {
    var g = Math.max(0, Math.round((fin10() - Date.now()) / 1000));
    var e = document.getElementById('odv-tm');
    if (!g) { if (e) rendre(); return; }
    if (e) e.textContent = mmss(g);
  }

  /* ---------------------------------------------- defilement et historique */
  var IOS_ANCIEN = (function () { var m = navigator.userAgent.match(/OS (\d+)_\d+(?:_\d+)? like Mac OS X/); return !!(m && +m[1] < 16); })();
  function verrou(on) {
    var b = document.body;
    if (on) {
      b.classList.add('overflow-hidden', 'ondivo-drawer-open');
      if (IOS_ANCIEN) { S.scrollY = window.scrollY; b.style.position = 'fixed'; b.style.top = -S.scrollY + 'px'; b.style.width = '100%'; }
    } else {
      b.classList.remove('overflow-hidden', 'ondivo-drawer-open');
      if (IOS_ANCIEN && b.style.position === 'fixed') { b.style.position = ''; b.style.top = ''; b.style.width = ''; window.scrollTo(0, S.scrollY); }
    }
  }

  function pousserHistoire() {
    try {
      if (history.state && history.state.ondivoDrawer) { S.histoire = true; return; }
      /* Sans geste reel de la cliente, Chrome saute l'entree a la touche retour. */
      if (navigator.userActivation && !navigator.userActivation.isActive) return;
      var sp = (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.searchParamsPrev != null) ? FacetFiltersForm.searchParamsPrev : location.search.slice(1);
      history.pushState(Object.assign({}, history.state || {}, { searchParams: sp, ondivoDrawer: 1 }), '');
      S.histoire = true;
    } catch (e) {}
  }

  /* ---------------------------------------------------------- l'element */
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      var self = this;
      this.addEventListener('keyup', function (e) { if (e.code === 'Escape') self.close(); });
      this.addEventListener('click', function (e) { self.clic(e); });
      var ov = this.querySelector('#CartDrawer-Overlay');
      if (ov) ov.addEventListener('click', function () { self.close(); });
      this.setHeaderCartIconAccessibility();
      donnees();
      rendre();
      window.addEventListener('popstate', function () { if (S.ouvert) self.close(true); });
      window.addEventListener('pageshow', function (e) { if (e.persisted && S.ouvert) relire(); });
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartError, function () {
            if (!S.attenteFiche) return;
            S.attenteFiche = false; S.Eaff = null; S.attendu = null; window.__odvCadeauOffert = false; clearTimeout(S.filetFiche);
            S.err = 'Non è stato possibile aggiungere il prodotto. Riprova.';
            relire();
          });
        }
      } catch (e) {}
      if (document.fonts && document.fonts.load) {
        Promise.all([document.fonts.load('400 14px Montserrat'), document.fonts.load('700 14px Montserrat')]).then(function () { rendre(true); }, function () {});
      }
      var rz;
      window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { rendre(true); }, 120); });
      /* Onglet perime (Dmitri) : un autre onglet a pu changer le panier. */
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { S.cache = true; return; }
        if (S.ouvert && !S.enVol && !S.attenteFiche) relire();
      });
      window.addEventListener('focus', function () { if (S.ouvert && !S.enVol && !S.attenteFiche) relire(); });
      /* Le panier peut avoir besoin d'une correction sans que la cliente ouvre
         le tiroir : cree dans un autre marche (Italie puis Suisse : remise
         perdue), ebook offert manquant (elle a quitte la fiche juste apres le
         clic : Dmitri), ebook en double ou payant, lignes kit a fusionner. Un
         checkout qui contourne le tiroir heriterait de ce panier : on le corrige
         au chargement de la page suivante, en silence, tiroir ferme. */
      try {
        if (S.panier && (S.panier.items || []).length && M.planifier(S.panier, M.etat(S.panier, CFG), CFG, {})) {
          setTimeout(function () { if (!S.ouvert && !S.enVol && !S.attenteFiche) relire(); }, 1500);
        }
      } catch (e) {}
      /* Retour du checkout : l'entree d'historique du tiroir est la page en cours. */
      try { if (history.state && history.state.ondivoDrawer) setTimeout(function () { self.open(); }, 0); } catch (e) {}
      if (window.__odvAjoutEnAttente) { var f = window.__odvAjoutEnAttente; window.__odvAjoutEnAttente = null; this.ouvrirAjout(f); }
    }

    setHeaderCartIconAccessibility() {
      var lien = document.querySelector('#cart-icon-bubble');
      if (!lien) return;
      var self = this;
      lien.setAttribute('role', 'button');
      lien.setAttribute('aria-haspopup', 'dialog');
      lien.addEventListener('click', function (e) { e.preventDefault(); self.open(lien); });
      lien.addEventListener('keydown', function (e) { if (e.code && e.code.toUpperCase() === 'SPACE') { e.preventDefault(); self.open(lien); } });
    }

    clic(e) {
      var b = e.target.closest && e.target.closest('[data-a]');
      if (!b || !this.contains(b) || b.disabled) return;
      var a = b.getAttribute('data-a'), k = b.getAttribute('data-key');
      if (a === 'close') return this.close();
      if (a === 'pay') {
        if ((S.enVol && !S.force) || S.attenteFiche || !S.lu) return;
        /* Plan §2.8 : le bouton part au checkout. On relit d'abord le panier
           seulement s'il n'a pas ete lu depuis 30 s ou si la cliente a quitte
           l'onglet (un autre onglet a pu le changer : test de Dmitri), ou si la
           derniere correction a echoue (ebook pas encore remis : Ling Long). Jamais
           deux refus de suite : au 2e appui, on part quoi qu'il arrive. */
        if (S.payeRefuse || (!S.cache && !S.douteux && Date.now() - S.dernierLu < 30000)) { window.location.assign(RACINE + 'checkout'); return; }
        var affiche = vue().total_price;
        S.lu = false; rendre();
        lirePanier().then(function (c) {
          S.cache = false;
          var aCorriger = M.planifier(c, M.etat(c, CFG), CFG, Object.assign({}, S.memo));
          if (c.total_price === affiche && !aCorriger) { window.location.assign(RACINE + 'checkout'); return; }
          S.payeRefuse = true;
          S.panier = c; S.E = verite(c);
          S.err = 'Il carrello è stato aggiornato. Controlla il totale.';
          pomper();
        }, function () { S.lu = true; window.location.assign(RACINE + 'checkout'); });
        return;
      }
      /* ONDIVO 30/10/2026 VIP : +/- sur un cadeau offert (creme, masques).
         Le cadeau reste 1 offert ; "+" ajoute une unite PAYANTE du meme produit
         (ligne creme ou masques du tiroir, avec ses propres paliers), "-" la
         retire. Sans unite payante, "-" ne fait rien (la poubelle retire le
         cadeau). */
      var cad = a.match(/^cad(-|\+)$/);
      if (cad && k) {
        var lc = (S.panier.items || []).filter(function (x) { return x.key === k; })[0];
        var rc = null;
        if (lc) ['cr', 'mk'].forEach(function (x) { if (CFG.ids[x] && Number(CFG.ids[x].p) === Number(lc.product_id)) rc = x; });
        if (!rc) return;
        appui(function (E) { E[rc] = cad[1] === '+' ? Math.min(3, (E[rc] || 0) + 1) : Math.max(0, (E[rc] || 0) - 1); });
        return;
      }
      /* ONDIVO 30/10/2026 VIP : +/- de la ligne VIP (voir quantiteVip). */
      var auV = a.match(/^au(-|\+)$/);
      if (auV && k) {
        var lv = (S.panier.items || []).filter(function (x) { return x.key === k; })[0], bv = lv && bundleVip(lv);
        if (bv) {
          if ((S.enVol && !S.force) || S.attenteFiche || !S.lu) return;
          var nq = auV[1] === '-' ? Math.max(1, lv.quantity - 1) : Math.min(10, lv.quantity + 1);
          /* ONDIVO 30/10/2026 : le - ne doit jamais faire MONTER le prix (2+3 VIP : pas de palier a 4, 5 kits 89,90 -> 4 kits 119,90). Dans ce cas on descend au palier inferieur. */
          var txv = 1; try { var t0 = parseFloat(Shopify.currency.rate); if (isFinite(t0) && t0 > 0) txv = t0; } catch (e) {}
          var uv = Number(lv.original_price) || 0;
          /* Le + saute au palier superieur quand il ne coute pas plus cher (2+3 : 3 kits 89,90 -> 5 kits 89,90, pas 4 kits 119,90). */
          if (auV[1] === '+' && uv) {
            var exact = (bv.offers || []).some(function (of) { return P.qte(of) === nq; });
            if (!exact) {
              var haut = null;
              (bv.offers || []).forEach(function (of) { var oq = P.qte(of); if (oq > nq && (!haut || oq < haut)) haut = oq; });
              if (haut && P.prix(bv, uv, haut, txv).net <= P.prix(bv, uv, nq, txv).net) nq = haut;
            }
          }
          if (auV[1] === '-') {
            if (uv && P.prix(bv, uv, nq, txv).net > P.prix(bv, uv, lv.quantity, txv).net) {
              var bas = null;
              (bv.offers || []).forEach(function (of) { var oq = P.qte(of); if (oq < lv.quantity && (!bas || oq > bas)) bas = oq; });
              if (bas) nq = bas;
            }
          }
          if (nq !== lv.quantity) quantiteVip(lv, bv, nq);
          return;
        }
      }
      appui(function (E) {
        var m = a.match(/^(kit|cr|mk)(-x|-|\+)$/);
        if (m) {
          var r = m[1], s = m[2], max = r === 'kit' ? 10 : 3;
          if (s === '-') E[r] = Math.max(1, E[r] - 1);
          else if (s === '+') E[r] = Math.min(max, E[r] + 1);
          else {
            if (r === 'kit') {
              var kl = (S.panier.items || []).filter(function (l) { return M.role(l, CFG) === 'kit'; })[0];
              S.kitRetire = { q: E.kit, props: kl ? kl.properties : null };
            }
            E[r] = 0;
          }
          if (r === 'kit' && s !== '-x') S.kitRetire = null;
          return;
        }
        if (a === 'undo' && S.kitRetire) { E.kit = S.kitRetire.q; if (S.kitRetire.props) E.kitProps = S.kitRetire.props; S.kitRetire = null; return; }
        if (a === 'eb-x') { E.ebRefus = true; return; }
        if (a === 'add-cr') { E.cr = Math.max(1, E.cr); return; }
        if (a === 'add-mk') { E.mk = Math.max(1, E.mk); return; }
        var au = a.match(/^au(-x|-|\+)$/);
        if (au && k) {
          var l = (S.panier.items || []).filter(function (x) { return x.key === k; })[0];
          var q = l ? l.quantity : 0;
          E.autres = E.autres || {};
          var cur = E.autres.hasOwnProperty(k) ? E.autres[k] : q;
          E.autres[k] = au[1] === '-' ? Math.max(1, cur - 1) : au[1] === '+' ? Math.min(10, cur + 1) : 0;
          /* ONDIVO 30/10/2026 VIP : retirer le kit VIP retire aussi ses cadeaux
             (meme bundle), sinon la creme offerte resterait seule, facturee. */
          var ol = l && M.offreLigne(l);
          if (au[1] === '-x' && ol && ol.main && M.bundleLigne(l) !== null) {
            (S.panier.items || []).forEach(function (x) {
              var ox = M.offreLigne(x);
              if (x.key !== k && ox && ox.gift && M.bundleLigne(x) === M.bundleLigne(l)) E.autres[x.key] = 0;
            });
          }
        }
      });
    }

    open(declencheur) {
      if (!donnees()) return;
      if (declencheur) this.setActiveElement(declencheur);
      if (!S.ouvert) {
        S.ouvert = true;
        poserFin10();
        rendre();
        verrou(true);
        var self = this;
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.classList.add('animate', 'active'); }); });
        var pan = document.getElementById('odv'), pousse = false;
        var pousser = function () { if (pousse || !S.ouvert) return; pousse = true; pousserHistoire(); };
        setTimeout(pousser, 400);
        if (pan) {
          var fini = function (ev) {
            if (ev.target !== pan || ev.propertyName !== 'transform') return;
            pan.removeEventListener('transitionend', fini);
            if (!S.ouvert) return;
            pousser();
            try { if (typeof trapFocus === 'function') trapFocus(pan, pan); } catch (e) {}
            try { pan.focus({ preventScroll: true }); } catch (e) {}
          };
          pan.addEventListener('transitionend', fini);
        }
        clearInterval(S.minuteur);
        S.minuteur = setInterval(tic, 1000);
      } else {
        rendre();
      }
      if (!S.attenteFiche && !S.enVol) relire();
    }

    close(depuisHistoire) {
      if (!S.ouvert) return;
      S.ouvert = false;
      if (S.attenteFiche) S.fermeeAjout = true;
      this.classList.remove('active');
      verrou(false);
      clearInterval(S.minuteur);
      try { if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement); } catch (e) {}
      try { if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true }); } catch (e) {}
      S.err = '';
      if (S.histoire) {
        S.histoire = false;
        try { if (!depuisHistoire && history.state && history.state.ondivoDrawer) history.back(); } catch (e) {}
      }
    }

    /* Appele par panier-rapide.liquid au moment du clic "Aggiungi al carrello"
       de la fiche : le tiroir s'ouvre tout de suite avec la ligne ajoutee
       (quantite et prix calcules par le meme code que la fiche). */
    ouvrirAjout(f) {
      if (!donnees()) return;
      var id = Number(((f && f.querySelector('[name="id"]')) || {}).value);
      var q = parseInt(((f && f.querySelector('[name="quantity"]')) || {}).value, 10) || 1;
      var r = null;
      ['kit', 'cr', 'mk'].forEach(function (x) { if (CFG.ids[x] && Number(CFG.ids[x].v) === id) r = x; });
      S.attenteFiche = true;
      S.fermeeAjout = false;
      S.err = '';
      var E2 = Object.assign({}, S.E);
      if (r) { E2[r] = (E2[r] || 0) + q; if (r === 'kit' && E2.kit >= 4) E2.ebRefus = false; }
      S.Eaff = r ? E2 : null;
      /* Garde de renderContents : apres l'ajout, le panier doit contenir AU MOINS
         la quantite ajoutee. Jamais plus : un panier perime (vide dans un autre
         onglet) gonflerait la garde (Bastian : 8 kits au lieu de 4). */
      S.attendu = r ? { r: r, q: q } : null;
      if (r === 'kit') S.kitRetire = null;
      clearTimeout(S.filetFiche);
      S.filetFiche = setTimeout(function () { if (S.attenteFiche) { S.attenteFiche = false; S.Eaff = null; relire(); } }, 8000);
      this.open(f && f.querySelector('[type="submit"]'));
    }

    /* Appele par product-form.js avec la reponse d'add.js (la ligne, pas un
       panier) : on attend l'ajout de l'ebook lance par bundle-natif, puis on
       relit /cart.js et on reconcilie. */
    renderContents() {
      if (!donnees()) return;
      var self = this, cadeau = window.__odvCadeau || null, offert = !!window.__odvCadeauOffert, attendu = S.attendu;
      window.__odvCadeauOffert = false; S.attendu = null;
      S.attenteFiche = true;
      if (!S.ouvert && !S.fermeeAjout) this.open();
      S.fermeeAjout = false;
      rendre();
      Promise.resolve(cadeau).catch(function () {}).then(lirePanier).then(function (c) {
        clearTimeout(S.filetFiche);
        window.__odvCadeau = null;
        S.panier = c;
        var v = M.etat(c, CFG);
        if (cadeau || offert) v.ebRefus = false; else v.ebRefus = !!S.E.ebRefus && v.ebRefus;
        /* Garde (Kenji) : on est sur la reponse d'un ajout ACCEPTE par Shopify,
           mais le panier ne le contient pas (ajout perdu par une ecriture
           concurrente). On le remet : le panier ne finit jamais vide. */
        if (attendu && v[attendu.r] < attendu.q) v[attendu.r] = attendu.q;
        S.E = v;
        S.attenteFiche = false; S.Eaff = null; S.lu = true;
        pomper();
      }, function () {
        clearTimeout(S.filetFiche);
        S.attenteFiche = false; S.Eaff = null;
        relire();
      });
      return self;
    }

    addItemToCart(variantId) {
      if (!donnees()) return;
      var r = null;
      ['kit', 'cr', 'mk'].forEach(function (x) { if (CFG.ids[x] && String(CFG.ids[x].v) === String(variantId)) r = x; });
      if (!this.classList.contains('active')) this.open();
      if (r) { S.dernierAppui = -1e9; appui(function (E) { E[r] = Math.min(r === 'kit' ? 10 : 3, (E[r] || 0) + 1); }); return; }
      xhr('POST', RACINE + 'cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] }).then(relire, function (e) { S.err = e.message; relire(); });
    }

    getSectionsToRender() { return []; }
    setActiveElement(el) { this.activeElement = el; }
    aEbookCadeau() { return !!(S.panier && (S.panier.items || []).some(function (l) { return M.role(l, CFG) === 'eb'; })); }
  }

  customElements.define('cart-drawer', CartDrawer);

  /* Crochet de test (?odv_test=1 seulement) : affiche un etat voulu sans
     requete, pour l'auto-test de mise en page dans le vrai theme. */
  if (/[?&]odv_test=1/.test(location.search)) {
    window.OdvTiroirTest = {
      afficher: function (E) {
        donnees();
        S.test = true;
        S.E = Object.assign({ kit: 0, cr: 0, mk: 0, ebRefus: false }, E);
        S.diff = true; S.lu = true; S.err = '';
        rendre();
        return vue();
      },
      etat: S
    };
  }

  /* Verrou cart.js (plan v15 §2.4) : ses fonctions reconstruisent l'ancien
     tiroir a partir du HTML de section. Elles ne doivent plus rien faire tant
     que le nouveau tiroir est la. */
  if (typeof window.updateCartDrawer === 'function' && !window.updateCartDrawer.__odv) {
    var ancien = window.updateCartDrawer;
    window.updateCartDrawer = function () { if (document.getElementById('odv')) return; return ancien.apply(this, arguments); };
    window.updateCartDrawer.__odv = true;
    if (window.cartFunctions) window.cartFunctions.updateCartDrawer = window.updateCartDrawer;
  }

  /* Gardes pour compatibilite : la page /cart utilise <cart-items> de cart.js. */
  /* class de cart.js : liaison lexicale globale, pas une propriete de window. */
  if (typeof CartItems === 'function' && !customElements.get('cart-drawer-items')) {
    customElements.define('cart-drawer-items', class extends CartItems {
      getSectionsToRender() { return []; }
    });
  }
})();
